import React, { useEffect, useMemo, useState } from "react";
import { getOffers, updateOffer } from "../api/recruitmentApi";
import { formatDate, normalizeList, statusClass } from "./hrUtils";
import "./HRShared.css";
import "./Joining.css";

const Joining = () => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  const loadItems = async () => {
    try {
      const response = await getOffers({ joining: true });
      setItems(normalizeList(response));
    } catch (requestError) {
      setError(requestError.message);
    }
  };

  useEffect(() => { loadItems(); }, []);

  const stats = useMemo(() => ({
    accepted: items.filter((item) => item.status === "Offer Accepted").length,
    confirmed: items.filter((item) => item.status === "Joining Confirmed").length,
    joined: items.filter((item) => item.status === "Joined").length,
    didNotJoin: items.filter((item) => item.status === "Did Not Join").length,
  }), [items]);

  const changeStatus = async (id, status) => {
    try {
      await updateOffer(id, { status });
      await loadItems();
    } catch (requestError) {
      setError(requestError.message);
    }
  };

  return (
    <div className="hr-page">
      <header className="hr-page-header">
        <div><h1>Upcoming Joinings</h1><p>Confirm joining, mark employees joined and record no-shows.</p></div>
      </header>
      {error && <div className="hr-error">{error}</div>}
      <section className="hr-kpi-grid">
        {[["Offer Accepted", stats.accepted],["Joining Confirmed",stats.confirmed],["Joined",stats.joined],["Did Not Join",stats.didNotJoin]].map(([label,value]) => (
          <article className="hr-card hr-kpi" key={label}><div className="hr-kpi-label">{label}</div><div className="hr-kpi-value">{value}</div></article>
        ))}
      </section>
      <div className="hr-table-wrap">
        <table className="hr-table">
          <thead><tr><th>Candidate</th><th>Position</th><th>Expected Joining</th><th>Documents</th><th>Status</th><th>Update</th></tr></thead>
          <tbody>
            {items.length ? items.map((item) => (
              <tr key={item._id}>
                <td><strong>{item.candidate?.candidateName || item.candidateName || "Candidate"}</strong></td>
                <td>{item.offeredDesignation || item.jobOpening?.jobTitle || "-"}</td>
                <td>{formatDate(item.expectedJoiningDate)}</td>
                <td>{item.documentsCompleted ? "Completed" : "Pending"}</td>
                <td><span className={`hr-status ${statusClass(item.status)}`}>{item.status}</span></td>
                <td>
                  <select className="hr-select hr-joining-select" value={item.status} onChange={(e) => changeStatus(item._id, e.target.value)}>
                    {["Offer Accepted","Joining Confirmed","Joined","Did Not Join"].map((status) => <option key={status}>{status}</option>)}
                  </select>
                </td>
              </tr>
            )) : <tr><td colSpan="6" className="hr-empty">No joining records found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Joining;
